import {useContext} from 'react';

import {useLocation} from 'react-router-dom';

import {CompanyRoutesContent} from './CompanyRoutesContent';
import {AppHeader} from '../../components/AppHeaders/AppHeader';
import {Loading} from '../../components/Loading/Loading';
import {PageContainer} from '../../components/PageContainer/PageContainer';
import {CompanyProvider} from '../../contexts/CompanyContext/CompanyProvider';
import {FeatureFlagContext} from '../../contexts/FeatureFlagContext/FeatureFlagContext';
import {UserContext} from '../../contexts/UserContext/UserContext';
import {isQuestionnairePage} from '../../utils/questionnaireUtils/isQuestionnairePage';

export const CompanyRoutes = () => {
  const {isUserLoggedIn} = useContext(UserContext);
  const location = useLocation();
  const headerType = isUserLoggedIn() && !isQuestionnairePage(location.pathname) ? 'company' : 'public';
  const {isLoading} = useContext(FeatureFlagContext);

  return (
    <CompanyProvider>
      <PageContainer>
        <AppHeader type={headerType} />
        {isLoading ? <Loading backDrop /> : <CompanyRoutesContent />}
      </PageContainer>
    </CompanyProvider>
  );
};
